import { YouTubeEmbed } from '@next/third-parties/google'
import React from 'react'

type VideoPropTypes = {
  className?: string
  videoId: string
  height?: number
  style?: string
}

export const YoutubeVideo: React.FC<VideoPropTypes> = ({ className, height, videoId, style }) => (
  <div className={`${className}`}>
    <YouTubeEmbed videoid={videoId} height={height} style={style} />
  </div>
)

export default YoutubeVideo
